// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2917":"af64a9519f53a3af","4044":"0d22c62b0235bff5","4515":"af64a9519f53a3af","4969":"1f7fb268de0c9f90","5264":"563d8aadad35a685","8378":"0b0e9453cd93710a"}[chunkId] + ".css";
};